import { render } from "./deleteConfig.vue?vue&type=template&id=40029af2&scoped=true"
import script from "./deleteConfig.vue?vue&type=script&lang=js"
export * from "./deleteConfig.vue?vue&type=script&lang=js"

import "./deleteConfig.vue?vue&type=style&index=0&id=40029af2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40029af2"]])

export default __exports__